import { createActionFactory, Feature } from '../../../shared';

export const toggleGroupExpandedAction = createActionFactory<{
    groupId: string;
    isExpanded: boolean;
}>('ToggleGroupExpandedAction', Feature.FolderManagement);
